<!--
 * @Description: 
 * @Author: fal
 * @Date: 2025-03-31 13:59:00
 * @FilePath: \xhlz_pc\src\project\components\jump.vue
 * @LastEditTime: 2025-09-25 13:54:53
-->
<template>
  <div class="jump">正在跳转...</div>
</template>

<script>
const PATH_MAP = {
  项目: { url: '/project/brife' },
  施工单位: { url: '/doer/index' },
  材料供应商: { url: '/supplier/index' },
  机械供应商: { url: '/supplier/index' },
  其他公司: { url: '/consult/index' },
};
export default {
  created() {
    let jumpData = localStorage.getItem('jumpData');
    console.log('jumpData', jumpData);
    if (jumpData) this.changeToken(JSON.parse(jumpData));
  },
  methods: {
    // 根据sign改变token
    changeToken(data) {
      let url = '';
      let reqData = { ...data };
      if (data.isAdmin) {
        url = data.type == '项目' ? '/project/adminLogin' : '/prise/adminLogin';
      } else {
        url = data.type == '项目' ? '/project/login' : '/prise/login';
      }
      delete reqData.type;
      delete reqData.isAdmin;
      this.$request.post(url, reqData).then((res) => {
        let user = res.data;
        if (data.type == '其他公司') {
          user.user_type = 5;
          user.register_type = 1;
          user.prise_id = user.prise?.id || '';
        }
        sessionStorage.setItem('newVersion', ['项目', '机械供应商', '材料供应商', '施工单位'].includes(data.type) ? 1 : 0);
        sessionStorage.setItem('userInfo', JSON.stringify(user));
        sessionStorage.setItem('token', res.token);
        sessionStorage.setItem('rule', JSON.stringify(res.auth));
        sessionStorage.setItem('navs', data.type);
        localStorage.removeItem('jumpData');
        this.$router.push({ path: PATH_MAP[data.type].url });
        // location.reload();
      });
    },
  },
};
</script>

<style scoped lang="less">
.jump {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-weight: bolder;
  color: #888;
}
</style>
